// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xVEM","delete":"styles_delete__3MSB8","update":"styles_update__IZs6K","add":"styles_add__1Hk3n"};